import React, { PropTypes, Component } from 'react';
import AddItemCard from '../../../generic-components/add-item-card/add-item-card';
import EditButton from '../../../generic-components/edit-button';
import OfferTable from '../../../generic-components/special-offer-tables/special-offer-table';
import { Divider } from 'material-ui';
import MouseOverEditDiv from '../../../../tc-ui/mouse-over-edit-div';
import { connect } from 'react-redux';
import HelperLink from '../helper-link';
import R from 'ramda';

const propTypes = {
  supplierEditable: PropTypes.bool,
  offers: PropTypes.array,
  openAddEditContractDialog: PropTypes.func,
  productType: PropTypes.string,
  inDiffing: PropTypes.bool,
  contractState: PropTypes.string,
  classes: PropTypes.object,
};
class LeftFour extends Component {
  shouldComponentUpdate(nextProps) {
    const propKeys = R.keys(propTypes).filter(key => propTypes[key] !== PropTypes.func);
    return !R.equals(R.pick(propKeys, this.props), R.pick(propKeys, nextProps));
  }
  render() {
    const {
      offers,
      openAddEditContractDialog,
      supplierEditable,
      productType,
      contractState,
      inDiffing,
      classes = {},
    } = this.props;

    const addNewOffer = () =>
      openAddEditContractDialog({
        type: 'manageExtrasOffers',
        title: 'Manage Special Offers',
        offersOrExtras: { type: 'offers', createNew: true },
      });
    return (
      <div id="offers" className={classes['main']}>
        {!inDiffing && <Divider style={{ marginTop: '24px', marginBottom: '24px' }} />}
        <HelperLink
          labelText="SPECIAL OFFERS"
          value="offers"
          showSync={Boolean(offers && offers.length)}
          actions={[
            {
              label: 'Manage Special Offers (Beta)',
              onTouchTap: () =>
                openAddEditContractDialog({
                  type: 'manageExtrasOffers',
                  title: 'Manage Special Offers',
                  offersOrExtras: { type: 'offers' },
                }),
            },
          ]}
        />
        {offers && offers.length ? (
          <div>
            {offers.map((offer, index) => {
              const openEditModal = toDelete => () =>
                openAddEditContractDialog({
                  type: 'manageExtrasOffers',
                  title: 'Manage Special Offers',
                  offersOrExtras: {
                    type: 'offers',
                    selectedId: offer._id,
                    toDelete,
                  },
                });
              return (
                <MouseOverEditDiv
                  extendPadding
                  key={index}
                  editable={supplierEditable}
                  actionButtons={
                    <EditButton
                      onEdit={openEditModal()}
                      onDelete={openEditModal(true)}
                      deleteButton
                    />
                  }
                >
                  <OfferTable
                    {...offer}
                    productType={productType}
                    contractState={contractState}
                    openEditModal={openEditModal()}
                    classes={classes}
                    offerIndex={index}
                  />
                  {index === offers.length - 1 ? undefined : <br />}
                </MouseOverEditDiv>
              );
            })}
            <div
              style={{
                marginTop: '12px',
                marginBottom: '24px',
                display: supplierEditable ? 'block' : 'none',
              }}
            >
              <AddItemCard
                text="Add another special offer"
                onClick={addNewOffer}
                editable={supplierEditable}
              />
            </div>
          </div>
        ) : (
          <div>
            <AddItemCard
              text="Add special offers"
              onClick={addNewOffer}
              editable={supplierEditable}
            />
          </div>
        )}
      </div>
    );
  }
}

LeftFour.propTypes = propTypes;

const mapStateToProps = ({ contracting }, { reducerName, offers }) => {
  if (offers) return { offers };
  return {
    offers: contracting[reducerName].getIn(['rightSideContent', 'offers'])
      ? contracting[reducerName].getIn(['rightSideContent', 'offers']).toJS()
      : [],
    supplierEditable: contracting[reducerName].getIn(['leftNav', 'supplierEditable']),
    contractState: contracting[reducerName].getIn(['leftNav', 'contractState']),
    productType: contracting[reducerName].getIn(['rightSideContent', 'productType']),
  };
};
export default connect(mapStateToProps)(LeftFour);



// WEBPACK FOOTER //
// ./src/app/components/contracting/contract-activities-products/product/left-column/left-four-offers.jsx